import {
  Avatar,
  Box,
  Grid,
  Typography
} from '@mui/material';

import av1 from '../assets/av1.webp';
import av2 from '../assets/av2.webp';
import av3 from '../assets/av3.webp';
import av4 from '../assets/av4.webp';
import av5 from '../assets/av5.webp';
import testimonial from '../assets/testimonial.webp';
import TestimonialComment from './TestimonialComments';

const Testimonials = () => {
  return (
    <Box 
    sx={{
                width: '100%',
                backgroundImage: `url(${testimonial})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                py: 5,
                fontFamily: 'Rajdhani, sans-serif',
            }}>
    <Box
    sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: { xs: 2, sm: 3 },
                    mx: 'auto',
                    // mt:'50px',
                    fontFamily: 'Nunito, sans-serif',
                }}
                maxWidth="lg">
      
    <Box sx={{ py: 6, textAlign: 'center' }}>
      {/* Section 1 */}
      <Typography variant="h5" gutterBottom fontSize={'18px'} fontFamily={'Rajdhani'} color='#0c5ADB'>
        Testimonial
      </Typography>
      <Typography variant="h3" fontWeight="bold" fontSize={'33px'} fontFamily={'Rajdhani'} color='#041424' pb={'24px'}>
        Customer’s Awesome Feedback
      </Typography>

      <Grid container spacing={2} justifyContent="center" sx={{ mb: 0 }}>
          <Avatar sx={{ width: 56, height: 56 }} alt="Remy Sharp" src={av1} />
          <Avatar sx={{ width: 56, height: 56 }} alt="Remy Sharp" src={av2} />
          <Avatar sx={{ width: 56, height: 56 }} alt="Remy Sharp" src={av3} />
          <Avatar sx={{ width: 56, height: 56 }} alt="Remy Sharp" src={av4} />
          <Avatar sx={{ width: 56, height: 56 }} alt="Remy Sharp" src={av5} />
      </Grid>
    <TestimonialComment/>
    </Box>
    </Box>
    </Box>
  );
};

export default Testimonials;
